import React, { useState } from 'react';
import { Card, Container, Form, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import ExcelJS from 'exceljs';
import { BASE_URL } from '../../components/APi';
import Navbar from '../../components/Navbar';
import Sidebar from '../../components/Sidebar';
import { baseexcel } from '../../Files/Subjects/Baseurl';

const Sortdateresult = () => {

  const additionalMessage = "For each area of your life with respect to Physical Health & Mental Health, answer the questions necessary out of the four questions below.";
  const education = "For each area of your life with respect to Work & Education, answer the questions necessary out of the four questions below.";
  const wealth = "For each area of your life with respect to Wealth, answer the questions necessary out of the four questions below.";
  const self = "For each area of your life with respect to Self Awareness, answer the questions necessary out of the four questions below.";


  // const workEducationLabels = [
  //   'education', 'job', 'Business', 'profession', 'knowledge', 'earnings',
  //   'competencies'
  //   , 'skills', 'leadership', 'teamSkills', 'transport',
  //   'lifestyleWork', 'goalsInWork'
  // ];
const workEducationLabels = [
  'education', 'job', 'Business', 'profession', 'knowledge', 'earnings',
  'competencies', 'skills', 'leadership', 'teamSkills', 'transport',
  'lifestyleWork', 'goalsInWork'
];
  const wealthLabels = [
    'income', 'savings', 'property', 'inheritance', 'assets', 'growth', 'expansion', 'personalgadgets', 'personalfinance', 'budgeting', 'planning', 'lifestyle', 'subscription', 'taxes', 'housing', 'liabilities', 'loans', 'luxuryandcomfort', 'technology', 'goals In Wealth',
  ];

  const selfAwarenessTopics = [
    "prayers", "discipline", "meditation", "reading", "music", "fashion",
    "travel", "reflecting", "creation", "confidence", "values",
    "learnings", "miracles", "spirituality", "devotion", "dreams",
    "future", "goalsInSelfAwareness"
  ];

  // const handleDownload = async (startDate, endDate) => {
  // const url = `/vmkp/excel/get/${startDate}/${endDate}`;

  //     try {
  //       const response = await axios.get(url, {
  //         headers: { Authorization: 'Bearer ' + localStorage.getItem('staffToken') },
  //       });

  //       const extractedData = response.data.map(item => {
  //         const row = {
  //           StartDate:item.startdate,
  //           EndDate:item.enddate,
  //           FullName: item.fullname,
  //           ContactNumber: item.contactnumber,
  //           EmailId: item.emailid,
  //           Gender: item.gender,
  //           Age: item.age,
  //           occupation: item.occupation,
  //           maritalstatus: item.maritalstatus,
  //           // country: item.country,
  //           state: item.state,
  //           city: item.city,
  //           address: item.address,
  //         };
  //   console.log(response.data);
  //         // Dynamically add questions for each relationship type
  //         Relationshpslabels.forEach((label) => {
  //           for (let i = 1; i <= 4; i++) {
  //             row[`${label} - Question ${i}`] = item[`${label.toLowerCase()}${i}`]; // API format
  //           }
  //         });

  //         // Dynamically add questions for each health type
  //         healthlabels.forEach((label) => {
  //           for (let i = 1; i <= 4; i++) {
  //             row[`${label} - Question ${i}`] = item[`${label.toLowerCase()}${i}`]; // API format
  //           }
  //         });

  //         // Dynamically add questions for each wealth type


  //         // Dynamically add questions for each work education type
  //         workeducationlabel.forEach((label) => {
  //           for (let i = 1; i <= 4; i++) {
  //             row[`${label} - Question ${i}`] = item[`${label.toLowerCase()}${i}`]; // API format
  //           }
  //         });
  //         wealthlabel.forEach((label) => {
  //           for (let i = 1; i <= 4; i++) {
  //             row[`${label} - Question ${i}`] = item[`${label.toLowerCase().replace(/ /g, '')}${i}`]; // Clean key for API format
  //           }
  //         });
  //         // Dynamically add questions for each self-awareness topic
  //         selfAwarenessTopics.forEach((label) => {
  //           for (let i = 1; i <= 4; i++) {
  //             row[`${label} - Question ${i}`] = item[`${label.toLowerCase()}${i}`]; // API format
  //           }
  //         });

  //         return row;
  //       });

  //       // Create a new workbook and a new worksheet
  //       const workbook = new ExcelJS.Workbook();
  //       const worksheet = workbook.addWorksheet("User Data");

  //       // Define the data for the sheet
  //       const data = [
  //         ["","","", "", "", "","","","","","","", "For each area of your life with respect to Relationships, Health, Wealth, Work Education, and Self Awareness, answer the questions necessary out of the four questions below.", ...Array(91).fill(""), additionalMessage,...Array(71).fill(""),education,...Array(51).fill(''),wealth,...Array(79).fill(" "),self],
  //         ["StartDate","EndDate","Full Name", "Contact Number", "Email ID", "Gender","Age","occupation","maritalstatus","state","city","address",
  //           ...Relationshpslabels.flatMap(label => 
  //             [`${label} - Is this area applicable for you?`, `${label} - Is this area working for you?`, `${label} - How critical is this area for you?`, `${label} - How do you see your future in this area?`]
  //           ),
  //           ...healthlabels.flatMap(label => 
  //             [`${label} - Is this area applicable for you?`, `${label} - Is this area working for you?`, `${label} -How critical is this area for you?`, `${label} - How do you see your future in this area?`]
  //           ),

  //           ...workeducationlabel.flatMap(label => 
  //             [`${label}  - Is this area applicable for you?`, `${label} - Is this area working for you?`, `${label} - How critical is this area for you?`, `${label}- How do you see your future in this area?`]
  //           ), ...wealthlabel.flatMap(label => 
  //             [`${label}  - Is this area applicable for you?`, `${label} -Is this area working for you?`, `${label} - How critical is this area for you?`, `${label} - How do you see your future in this area?`]
  //           ),
  //           ...selfAwarenessTopics.flatMap(label => 
  //             [`${label}  - Is this area applicable for you?`, `${label} -Is this area working for you?`, `${label} - How critical is this area for you?`, `${label} - How do you see your future in this area?`]
  //           )
  //         ], // Dynamic headers for all categories
  //         ...extractedData.map(row => [
  // row.StartDate, 
  // row.EndDate,
  //           row.FullName, 
  //           row.ContactNumber, 
  //           row.EmailId, 
  //           row.Gender,row.Age,row.occupation,row.maritalstatus,row.state,row.city,row.address,
  //           ...Relationshpslabels.flatMap(label => [
  //             row[`${label} - Question 1`],
  //             row[`${label} - Question 2`],
  //             row[`${label} - Question 3`],
  //             row[`${label} - Question 4`]
  //           ]),
  //           ...healthlabels.flatMap(label => [
  //             row[`${label} - Question 1`],
  //             row[`${label} - Question 2`],
  //             row[`${label} - Question 3`],
  //             row[`${label} - Question 4`]
  //           ]),  ...workeducationlabel.flatMap(label => [
  //             row[`${label} - Question 1`],
  //             row[`${label} - Question 2`],
  //             row[`${label} - Question 3`],
  //             row[`${label} - Question 4`]
  //           ]),
  //           ...wealthlabel.flatMap(label => [
  //             row[`${label} - Question 1`],
  //             row[`${label} - Question 2`],
  //             row[`${label} - Question 3`],
  //             row[`${label} - Question 4`]
  //           ]),

  //           ...selfAwarenessTopics.flatMap(label => [
  //             row[`${label} - Question 1`],
  //             row[`${label} - Question 2`],
  //             row[`${label} - Question 3`],
  //             row[`${label} - Question 4`]
  //           ])
  //         ])
  //       ];

  //       // Add data to the worksheet
  //       data.forEach((row) => {
  //         worksheet.addRow(row);
  //       });

  //       const headerCells = worksheet.getRow(1);
  //       headerCells.eachCell(cell => {
  //         // Check if the cell matches specific header values
  //         if (cell.value === "For each area of your life with respect to Relationships, Health, Wealth, Work Education, and Self Awareness, answer the questions necessary out of the four questions below.") {
  //           cell.fill = {
  //             type: 'pattern',
  //             pattern: 'solid',
  //             fgColor: { argb: '3E74D1' } // Background color for this header
  //           };
  //           cell.font = {
  //             color: { argb: 'FFFFFFFF' }, // White font color
  //             bold: true,
  //             size: 12
  //           };
  //         } else if (cell.value === additionalMessage) {
  //           cell.fill = {
  //             type: 'pattern',
  //             pattern: 'solid',
  //             fgColor: { argb: 'FFBD16' }  
  //           };
  //           cell.font = {
  //             color: { argb: 'FFFFFFFF' }, 
  //             bold: true,
  //             size: 12
  //           };
  //         }else if (cell.value === education) {
  //           cell.fill = {
  //             type: 'pattern',
  //             pattern: 'solid',
  //             fgColor: { argb: 'E22146' }  
  //           };
  //           cell.font = {
  //             color: { argb: 'FFFFFFFF' },   
  //             bold: true,
  //             size: 12
  //           };
  //         }else if (cell.value === wealth) {
  //           cell.fill = {
  //             type: 'pattern',
  //             pattern: 'solid',
  //             fgColor: { argb: '45B43B' }  
  //           };
  //           cell.font = {
  //             color: { argb: 'FFFFFFFF' },   
  //             bold: true,
  //             size: 12
  //           };
  //         }else if (cell.value === self) {
  //           cell.fill = {
  //             type: 'pattern',
  //             pattern: 'solid',
  //             fgColor: { argb: '3D3D3D' }  
  //           };
  //           cell.font = {
  //             color: { argb: 'FFFFFFFF' },  
  //             bold: true,
  //             size: 12
  //           };
  //         }
  //       });

  //       const secondRowCells = worksheet.getRow(2);   
  //       secondRowCells.eachCell(cell => {
  //          if (typeof cell.value === 'string') {
  //           cell.value = cell.value.toUpperCase();  
  //         }
  //         cell.font = {
  //           bold: true,   
  //           size: 12      
  //         };
  //       });

  //       // Generate the Excel file and initiate download
  //       const buffer = await workbook.xlsx.writeBuffer();
  //       const blob = new Blob([buffer], { type: "application/octet-stream" });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `data_${startDate}.xlsx`;
  //       link.click();
  //     } catch (error) {
  //       console.error('Download failed:', error);
  //     }
  // };



  // const handleDownload = async (startDate, endDate) => {
  //   const routes = [
  //     `/vmkp/excel/getcu/${startDate}/${endDate}`,
  //     `/vmkp/excel/get/${startDate}/${endDate}`,
  //     `/vmkp/excel/get1/${startDate}/${endDate}`,
  //     `/vmkp/excel/get2/${startDate}/${endDate}`,
  //     `/vmkp/excel/get3/${startDate}/${endDate}`,
  //     `/vmkp/excel/get4/${startDate}/${endDate}`,
  //     `/vmkp/excel/get5/${startDate}/${endDate}`,
  //     `/vmkp/excel/get6/${startDate}/${endDate}`,
  //     `/vmkp/excel/get7/${startDate}/${endDate}`,
  //     `/vmkp/excel/get8/${startDate}/${endDate}`,
  //     `/vmkp/excel/get9/${startDate}/${endDate}`,
  //     `/vmkp/excel/get10/${startDate}/${endDate}`,
  //     `/vmkp/excel/get11/${startDate}/${endDate}`,
  //     `/vmkp/excel/get12/${startDate}/${endDate}`,
  //     `/vmkp/excel/get13/${startDate}/${endDate}`
  //   ];

  //   try {
  //     // Fetch all data
  //     const responses = await Promise.all(routes.map((url) => axios.get(url)));

  //     // Map responses data to variables
  //     const [
  //       customerRelationships,
  //       romanticRelationships,
  //       friendsAndFWB,
  //       colleaguesAndConflicts,
  //       healthGoals,
  //       nutritionAndHygiene,
  //       emotionalState,
  //       educationAndJob,
  //       workSkills,
  //       incomeAssets,
  //       personalFinance,
  //       housingAndComfort,
  //       selfAwareness1,
  //       selfAwareness2,
  //       selfAwareness3
  //     ] = responses.map(res => res.data);

  //     const data = {
  //       customerRelationships,
  //       romanticRelationships,
  //       friendsAndFWB,
  //       colleaguesAndConflicts,
  //       healthGoals,
  //       nutritionAndHygiene,
  //       emotionalState,
  //       educationAndJob,
  //       workSkills,
  //       incomeAssets,
  //       personalFinance,
  //       housingAndComfort,
  //       selfAwareness1,
  //       selfAwareness2,
  //       selfAwareness3
  //     };

  //     console.log(data);

  //     // Export to Excel
  //     await exportToExcel(data);

  //   } catch (error) {
  //     console.error("Error fetching or exporting data:", error);
  //   }
  // };

  // const exportToExcel = async (data) => {
  //   const workbook = new ExcelJS.Workbook();

  //   for (const [sheetName, sheetData] of Object.entries(data)) {
  //     const worksheet = workbook.addWorksheet(sheetName);

  //     if (Array.isArray(sheetData) && sheetData.length > 0) {
  //       // Extract headers from first object keys
  //       const headers = Object.keys(sheetData[0]);
  //       // Add header row with bold styling
  //       const headerRow = worksheet.addRow(headers);
  //       headerRow.font = { bold: true };

  //       // Add data rows
  //       sheetData.forEach(item => {
  //         const row = headers.map(header => item[header]);
  //         worksheet.addRow(row);
  //       });
  //     }
  //   }

  //   // Write workbook to buffer
  //   const buffer = await workbook.xlsx.writeBuffer();

  //   // Create a blob and trigger browser download
  //   const blob = new Blob([buffer], {
  //     type:
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = "data_export.xlsx";
  //   a.click();

  //   // Clean up
  //   window.URL.revokeObjectURL(url);
  // };

  // const handleDownload = async (startDate, endDate) => {
  //   try {
  //     const url = `/vmkp/excel/getcu/${startDate}/${endDate}`;
  //     const res = await axios.get(url);
  //     const customerData = res.data;

  //     await exportCustomerDetails(customerData);
  //   } catch (error) {
  //     console.error("Error fetching or exporting customer data:", error);
  //   }
  // };

  // const exportCustomerDetails = async (customerData) => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Customer Details');

  //   if (!Array.isArray(customerData) || customerData.length === 0) {
  //     console.warn("No customer data to export");
  //     return;
  //   }

  //   // Define the column order you want
  //   const customOrder = [
  //      "startdate",
  //     "enddate",
  //     "fullname",
  //     "age",
  //     "gender",
  //     "maritalstatus",
  //     "occupation",
  //     "address",
  //     "city",
  //     "state",
  //     "country",
  //     "contactnumber",
  //     "emailid",

  //   ];

  //   // Filter keys that actually exist
  //   const headers = customOrder.filter((key) => key in customerData[0]);

  //   // Add big heading in first row and merge across all headers
  //   worksheet.mergeCells(1, 1, 1, headers.length);
  //   const titleCell = worksheet.getCell(1, 1);
  //   titleCell.value = "Customer Details";
  //   titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
  //   titleCell.font = { size: 16, bold: true };

  //   // Add headers in second row
  //   const headerRow = worksheet.addRow(headers);
  //   headerRow.font = { bold: true };
  //   headerRow.alignment = { horizontal: 'center' };

  //   // Add data rows starting from third row
  //   customerData.forEach(item => {
  //     const row = headers.map(h => item[h] ?? "");
  //     worksheet.addRow(row);
  //   });

  //   // Optional: Adjust column widths
  //   headers.forEach((header, idx) => {
  //     worksheet.getColumn(idx + 1).width = Math.max(header.length + 2, 15);
  //   });

  //   // Generate buffer and trigger download
  //   const buffer = await workbook.xlsx.writeBuffer();

  //   const blob = new Blob([buffer], {
  //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //   });

  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = 'customer_details.xlsx';
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  // };
  // const Relationshpslabels =  [
  //   'Mother', 'Father', 'Children', 'Grandparents', 'Partner', 'Spouse',
  //   'Siblings', 'Girlfriends', 'Boyfriends', 'Friends', 'friendswithbenefits',
  //   'Relatives', 'Communities', 'Boss', 'Colleague', 'Teacher', 'Classmate',
  //   'Conflicts', 'Love', 'Intimacy', 'Sex', 'Commitments', 'goalsinrelationship'
  // ];
  
  const customerFields = [
    "startdate", "enddate", "fullname", "age", "gender", "maritalstatus", "occupation",
    "address", "city", "state", "country", "contactnumber", "emailid","examstartdate","starttime","endtime","couponname","paymentamount"
  ];
  const questionSuffixes = [
    " - IS THIS AREA APPLICABLE FOR YOU?",
    " - IS THIS AREA WORKING FOR YOU?",
    " - HOW CRITICAL IS THIS AREA FOR YOU?",
    " - HOW DO YOU SEE YOUR FUTURE IN THIS AREA?"
  ];



  const [loading, setLoading] = useState(false);
const relationshipLabels = [
    'Mother', 'Father', 'Children', 'Grandparents', 'Partner', 'Spouse',
    'Siblings', 'Girlfriends', 'Boyfriends', 'Friends', 'friendswithbenefits',
    'Relatives', 'Communities', 'Boss', 'Colleague', 'Teacher', 'Classmate',
    'Conflicts', 'Love', 'Intimacy', 'Sex', 'Commitments', 'goalsinrelationship'
  ];

  const healthLabels = [
    'weight', 'Fitness', 'Vitality', 'Power', 'Diseases', 'Nutrition', 'Diet', 'Cooking', 'Hygiene', 'personalcare', 'Sports', 'Entertainment', 'Emotion',
    'Traumas', 'Stress', 'Vacation', 'lifestyleinhealth', 'goalsinhealth', ,


  ];

 

function generateDynamicHeaders(label) {
  const questionSuffixes = [
    ' - IS THIS AREA APPLICABLE FOR YOU?',
    ' - IS THIS AREA WORKING FOR YOU?',
    ' - HOW CRITICAL IS THIS AREA FOR YOU?',
    ' - HOW DO YOU SEE YOUR FUTURE IN THIS AREA?'
  ];
  return questionSuffixes.map(suffix => label.toUpperCase() + suffix);
}

 
const handleDownload = async (startDate, endDate) => {
  setLoading(true);
    // `/vmkp/excel/getcu/${startDate}/${endDate}`,

  const routes = [
    `${baseexcel}excel/getcu/${startDate}/${endDate}`,
    `${baseexcel}excel/get/${startDate}/${endDate}`,
    `${baseexcel}excel/get1/${startDate}/${endDate}`,
    `${baseexcel}excel/get2/${startDate}/${endDate}`,
    `${baseexcel}excel/get3/${startDate}/${endDate}`,
    `${baseexcel}excel/get4/${startDate}/${endDate}`,
    `${baseexcel}excel/get5/${startDate}/${endDate}`,
    `${baseexcel}excel/get6/${startDate}/${endDate}`,
    `${baseexcel}excel/get7/${startDate}/${endDate}`,
    `${baseexcel}excel/get8/${startDate}/${endDate}`,
    `${baseexcel}excel/get9/${startDate}/${endDate}`,
    `${baseexcel}excel/get10/${startDate}/${endDate}`,
    `${baseexcel}excel/get11/${startDate}/${endDate}`,
    `${baseexcel}excel/get12/${startDate}/${endDate}`,
    `${baseexcel}excel/get13/${startDate}/${endDate}`,
  ];

  try {
    const resArr = await Promise.all(routes.map(url => axios.get(url)));
    const [
      customerRes, rel1, rel2, rel3, rel4, health, nutrition, emotion, workeducation,
      wealth1, wealth2, wealth3, self1, self2, self3
    ] = resArr.map(r => r.data);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Full Export");

    const relationshipData = rel1.map((item, i) => ({
      ...item,
      ...rel2[i],
      ...rel3[i],
      ...rel4[i],
      ...health[i],
      ...nutrition[i],
      ...emotion[i],
      ...workeducation[i],
      ...wealth1[i],
      ...wealth2[i],
      ...wealth3[i],
      ...self1[i],
      ...self2[i],
      ...self3[i],
    }));

    const customerHeaders = customerFields.map(f => f.toUpperCase());
    const allRelKeys = Object.keys(relationshipData[0] || {});
    const orderedRelKeys = [];
    const relationshipHeaders = [];

    const allLabels = [
      ...relationshipLabels,
      ...healthLabels.filter(Boolean),
      ...workEducationLabels,
      ...wealthLabels,
      ...selfAwarenessTopics,
    ];

    allLabels.forEach(label => {
      const lowerLabel = label.toLowerCase().replace(/\s/g, "");
      let keys = allRelKeys
        .filter(k => new RegExp(`^${lowerLabel}\d*$`).test(k.toLowerCase()))
        .sort((a, b) => {
          const numA = parseInt(a.slice(lowerLabel.length)) || 0;
          const numB = parseInt(b.slice(lowerLabel.length)) || 0;
          return numA - numB;
        });

      if (keys.length === 0) {
        keys = [1, 2, 3, 4].map(n => `${lowerLabel}${n}`);
      }

      const dynHeaders = generateDynamicHeaders(label);
      keys.forEach((key, idx) => {
        orderedRelKeys.push(key);
        relationshipHeaders.push(dynHeaders[idx] || key.toUpperCase());
      });
    });

    let colStart = 1;
    const setHeading = (label, count, color = 'FF4BACC6') => {
      const start = colStart;
      const end = colStart + count - 1;
      worksheet.mergeCells(1, start, 1, end);
      for (let i = start; i <= end; i++) {
        const cell = worksheet.getCell(1, i);
        if (i === start) cell.value = label;
        cell.font = { bold: true, size: 16, color: { argb: 'FFFFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: color } };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'medium' }, left: { style: 'medium' },
          bottom: { style: 'medium' }, right: { style: 'medium' }
        };
      }
      worksheet.getRow(1).height = 30;
      colStart = end + 1;
    };

    const relLabelCount = relationshipLabels.length * 4;
    const healthLabelCount = healthLabels.filter(Boolean).length * 4;
    const workEduLabelCount = workEducationLabels.length * 4;
    const wealthLabelCount = wealthLabels.length * 4;
    const selfAwarenessLabelCount = selfAwarenessTopics.length * 4;

    setHeading("CUSTOMER DETAILS", customerHeaders.length, 'B1A0C7');
    setHeading("RELATIONSHIPS", relLabelCount, '4481c5');
    setHeading("HEALTH", healthLabelCount, 'FFBD16');
    setHeading("WORK & EDUCATION", workEduLabelCount, 'f90945');
    setHeading("WEALTH", wealthLabelCount, '45b43b');
    setHeading("SELF AWARENESS", selfAwarenessLabelCount, '3d3d3d');

    let colIndex = 1;
    const writeHeaders = headers => headers.forEach(h => {
      const cell = worksheet.getCell(2, colIndex++);
      cell.value = h;
      cell.font = { bold: true, color: { argb: 'FF000000' } };
      cell.fill = {
        type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDBE5F1' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin' }, left: { style: 'thin' },
        bottom: { style: 'thin' }, right: { style: 'thin' }
      };
    });

    writeHeaders(customerHeaders);
    writeHeaders(relationshipHeaders);

    worksheet.views = [{ state: 'frozen', ySplit: 2 }];

    for (let i = 0; i < customerRes.length; i++) {
      const row = worksheet.getRow(i + 3);
      const isEven = i % 2 === 0;
      let col = 1;

      const writeData = (obj, keys) => {
        keys.forEach(key => {
          const cell = row.getCell(col++);
          cell.value = obj?.[key] ?? "";
          cell.alignment = { vertical: 'top', horizontal: 'left' };
          cell.border = {
            top: { style: 'thin' }, bottom: { style: 'thin' },
            left: { style: 'thin' }, right: { style: 'thin' },
          };
          if (isEven) {
            cell.fill = {
              type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' },
            };
          }
        });
      };

      writeData(customerRes[i], customerFields);
      writeData(relationshipData[i], orderedRelKeys);
    }

    worksheet.columns.forEach(col => {
      let maxLength = 10;
      col.eachCell({ includeEmpty: true }, cell => {
        const value = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, value.length);
      });
      col.width = maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Full_Report_${startDate}_to_${endDate}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Download failed:", error);
  } finally {
    setLoading(false);
  }
};


// const handleDownload = async (startDate, endDate) => {
//   setLoading(true);

//   const routes = [
//     `/vmkp/excel/getcu/${startDate}/${endDate}`,  // 0
//     `/vmkp/excel/get/${startDate}/${endDate}`,   // 1
//     `/vmkp/excel/get1/${startDate}/${endDate}`,  // 2
//     `/vmkp/excel/get2/${startDate}/${endDate}`,  // 3
//     `/vmkp/excel/get3/${startDate}/${endDate}`,  // 4
//     `/vmkp/excel/get4/${startDate}/${endDate}`,  // 5 (health)
//     `/vmkp/excel/get5/${startDate}/${endDate}`,  // 6 (nutrition)
//     `/vmkp/excel/get6/${startDate}/${endDate}`,  // 7 (emotion)
//     `/vmkp/excel/get7/${startDate}/${endDate}`,  // 8 (work/edu)
//     `/vmkp/excel/get8/${startDate}/${endDate}`,  // 9 (wealth 1)
//     `/vmkp/excel/get9/${startDate}/${endDate}`,  // 10 (wealth 2)
//     `/vmkp/excel/get10/${startDate}/${endDate}`, // 11 (wealth 3)
//   ];

//   try {
//     const resArr = await Promise.all(routes.map(url => axios.get(url)));
//     const [
//       customerRes, rel1, rel2, rel3, rel4, health, nutrition, emotion, workeducation,
//       wealth1, wealth2, wealth3
//     ] = resArr.map(r => r.data);

//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet("Full Export");

//     const relationshipData = rel1.map((item, i) => ({
//       ...item,
//       ...rel2[i],
//       ...rel3[i],
//       ...rel4[i],
//       ...health[i],
//       ...nutrition[i],
//       ...emotion[i],
//       ...workeducation[i],
//       ...wealth1[i],
//       ...wealth2[i],
//       ...wealth3[i],
//     }));

//     const customerHeaders = customerFields.map(f => f.toUpperCase());

//     const allRelKeys = Object.keys(relationshipData[0] || {});
//     const orderedRelKeys = [];
//     const relationshipHeaders = [];

//     const allLabels = [
//       ...relationshipLabels,
//       ...healthLabels.filter(Boolean),
//       ...workEducationLabels,
//       ...wealthLabels,
//     ];

//     allLabels.forEach(label => {
//       const lowerLabel = label.toLowerCase().replace(/\s/g, "");
//       let keys = allRelKeys
//         .filter(k => new RegExp(`^${lowerLabel}\\d*$`).test(k.toLowerCase()))
//         .sort((a, b) => {
//           const numA = parseInt(a.slice(lowerLabel.length)) || 0;
//           const numB = parseInt(b.slice(lowerLabel.length)) || 0;
//           return numA - numB;
//         });

//       if (keys.length === 0) {
//         keys = [1, 2, 3, 4].map(n => `${lowerLabel}${n}`);
//       }

//       const dynHeaders = generateDynamicHeaders(label);
//       keys.forEach((key, idx) => {
//         orderedRelKeys.push(key);
//         relationshipHeaders.push(dynHeaders[idx] || key.toUpperCase());
//       });
//     });

//     let colStart = 1;
//     const setHeading = (label, count, color = 'FF4BACC6') => {
//       const start = colStart;
//       const end = colStart + count - 1;
//       worksheet.mergeCells(1, start, 1, end);
//       for (let i = start; i <= end; i++) {
//         const cell = worksheet.getCell(1, i);
//         if (i === start) cell.value = label;
//         cell.font = { bold: true, size: 16, color: { argb: 'FFFFFFFF' } };
//         cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: color } };
//         cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
//         cell.border = {
//           top: { style: 'medium' }, left: { style: 'medium' },
//           bottom: { style: 'medium' }, right: { style: 'medium' }
//         };
//       }
//       worksheet.getRow(1).height = 30;
//       colStart = end + 1;
//     };

//     // Determine sizes to split the sections
//     const relLabelCount = relationshipLabels.length * 4;
//     const healthLabelCount = healthLabels.filter(Boolean).length * 4;
//     const workEduLabelCount = workEducationLabels.length * 4;
//     const wealthLabelCount = wealthLabels.length * 4;

//     setHeading("CUSTOMER DETAILS", customerHeaders.length, 'FF1F4E78');
//     setHeading("RELATIONSHIPS", relLabelCount, 'FF4BACC6');
//     setHeading("HEALTH", healthLabelCount, 'FF70AD47');
//     setHeading("WORK & EDUCATION", workEduLabelCount, 'FF7030A0');
//     setHeading("WEALTH", wealthLabelCount, 'FFFF9900');

//     let colIndex = 1;
//     const writeHeaders = headers => headers.forEach(h => {
//       const cell = worksheet.getCell(2, colIndex++);
//       cell.value = h;
//       cell.font = { bold: true, color: { argb: 'FF000000' } };
//       cell.fill = {
//         type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDBE5F1' }
//       };
//       cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
//       cell.border = {
//         top: { style: 'thin' }, left: { style: 'thin' },
//         bottom: { style: 'thin' }, right: { style: 'thin' }
//       };
//     });

//     writeHeaders(customerHeaders);
//     writeHeaders(relationshipHeaders);

//     worksheet.views = [{ state: 'frozen', ySplit: 2 }];

//     for (let i = 0; i < customerRes.length; i++) {
//       const row = worksheet.getRow(i + 3);
//       const isEven = i % 2 === 0;
//       let col = 1;

//       const writeData = (obj, keys) => {
//         keys.forEach(key => {
//           const cell = row.getCell(col++);
//           cell.value = obj?.[key] ?? "";
//           cell.alignment = { vertical: 'top', horizontal: 'left' };
//           cell.border = {
//             top: { style: 'thin' }, bottom: { style: 'thin' },
//             left: { style: 'thin' }, right: { style: 'thin' },
//           };
//           if (isEven) {
//             cell.fill = {
//               type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' },
//             };
//           }
//         });
//       };

//       writeData(customerRes[i], customerFields);
//       writeData(relationshipData[i], orderedRelKeys);
//     }

//     worksheet.columns.forEach(col => {
//       let maxLength = 10;
//       col.eachCell({ includeEmpty: true }, cell => {
//         const value = cell.value ? cell.value.toString() : '';
//         maxLength = Math.max(maxLength, value.length);
//       });
//       col.width = maxLength + 2;
//     });

//     const buffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([buffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//     });

//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `Full_Report_${startDate}_to_${endDate}.xlsx`;
//     a.click();
//     URL.revokeObjectURL(url);

//   } catch (error) {
//     console.error("Download failed:", error);
//   } finally {
//     setLoading(false);
//   }
// };


  const handleSubmit = (e) => {
    e.preventDefault();
    const startDate = e.target.startDate.value;
    const endDate = e.target.endDate.value;

    handleDownload(startDate, endDate, setLoading);
  };

  return (
       <Card>
        <Card.Header as="h5">Export Result to Excel</Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col">
                <Form.Group controlId="formStartDate">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control type="date" name="startDate" required />
                </Form.Group>
              </div>
              <div className="col">
                <Form.Group controlId="formEndDate">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control type="date" name="endDate" required />
                </Form.Group>
              </div>
            </div>
            <br />
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Generating Excel...
                </>
              ) : (
                "Download Excel"
              )}
            </Button>
          </Form>
        </Card.Body>
      </Card>
   );
};

export default Sortdateresult;
